import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    sectionHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            flexDirection: 'column'
        }
    },
    sectionHeading: {
        fontWeight: 500
    },
    sectionContent: {
        margin: '25px 0px',
        backgroundColor: '#F5F5F5',
        display: 'block',
        padding: 30,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            padding: 15
        },
        '& span': {
            width: '30px !important',
            height: '30px !important'
        }
    },
    deleteBankButton: {
        padding: '0px',
        justifyContent: 'flex-start',
        height: 24
    },
    addBankButton: {
        padding: '0px',
        justifyContent: 'flex-start',
        height: 24
    },
    detailsItem: {
        marginBottom: 15,
        fontWeight: 500,
        lineHeight: '1.3',
        fontFamily: 'CircularStd'
    },
    detailsItemHeading: {
        color: '#A4A4A4',
        fontSize: 14,
        marginBottom: 4
    },
    detailsItemValue: {
        color: '#4A4A4A',
        fontSize: 16,
        wordWrap:'break-word'
    },
    noBankFoundWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: 15,
        alignSelf: 'stretch'
    },
    bankIconRing: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '3px solid #CCCCCC',
        borderRadius: '50%',
        padding: '15px',
    },
    bankIcon: {
        height: 25,
        width: 25
    },
    noBankRightSection: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 10
    },
    noBankDetailsText: {
        fontSize: 16,
        fontWeight: 500
    }
});